import { useState } from "react";

import {
  AtsIntegration,
  PageUpIntegrationContext,
} from "./PageUpIntegrationContext";
import { PageUpSetupStep } from "./components/steps/PageUpSetupStep";
import { getDefaultDatacenter } from "./utils";

export function PageUpIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    client_id: "",
    client_secret: "",
    environment: "UAT",
    datacenter_id: getDefaultDatacenter(),
    default_group_id: "",
    report_url_type: "CLIENT_PORTAL_URL",
  });

  return (
    <PageUpIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
      }}
    >
      <PageUpSetupStep />
    </PageUpIntegrationContext.Provider>
  );
}
